import styles from '../assets/css/member-registration.module.css';
import { basicInfoFields, emergencyFields, familyFields } from '../assets/js/confirmFields';
import { toWareki } from '../utils/wareki';

// 生年月日は和暦を併記して表示する
const displayValue = (key, value) => {
  if (key === 'birthdate' && value) {
    const wareki = toWareki(value);
    return wareki ? `${value}（${wareki}）` : value;
  }
  return value;
};

function ConfirmForm({ formData, familyMembers }) {
  const hasDependents = formData.has_dependents;
  const visibleFamilyMembers = (familyMembers || []).filter(
    member => familyFields.some(field => member[field.key])
  );

  return (
    <div className={styles["registration-card"]}>
      <h1 className={`${styles["text-primary"]} text-center mb-4`}>登録内容確認</h1>

      <h2 className={styles["section-title"]}>基本情報（* 必須項目）</h2>
      <table className={styles["details-table"]}>
        <tbody>
          {basicInfoFields.map(field => (
            <tr key={field.key}>
              <th>
                {field.label}
                {field.required && <span>*</span>}
              </th>
              <td>{displayValue(field.key, formData[field.key])}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h2 className={styles["section-title"]}>緊急連絡先情報</h2>
      <table className={styles["details-table"]}>
        <tbody>
          {emergencyFields.map(field => (
            <tr key={field.key}>
              <th>
                {field.label}
                {field.required && <span>*</span>}
              </th>
              <td>{formData[field.key]}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h2 className={styles["section-title"]}>扶養家族情報（登録有の場合 * 必須）</h2>
      <table className={styles["details-table"]}>
        <tbody>
          <tr>
            <th>扶養家族の有無<span>*</span></th>
            <td>{hasDependents || '未選択'}</td>
          </tr>
        </tbody>
      </table>
      {hasDependents !== '無' && visibleFamilyMembers.length > 0 && (
        <table className={styles["details-table"]}>
          <thead>
            <tr>
              {familyFields.map(field => (
                <th key={field.key}>
                  {field.label}
                  {field.required && <span>*</span>}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {visibleFamilyMembers.map((member, index) => (
              <tr key={index}>
                {familyFields.map(field => (
                  <td key={field.key}>{displayValue(field.key, member[field.key])}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default ConfirmForm;
